var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","lg6":""}},[_c('Login')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }